import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout, Flex } from 'antd';
import clsx from 'clsx';
import useIsMobile from 'hooks/useIsMobile';
import useSessionInitialSetup from 'hooks/useSessionInitialSetup';
import If from 'components/If';
import Sidebar from 'components/Sidebar';
import Footer from 'components/Footer/Footer';
import CriticalNotification from 'components/CriticalNotification';
import SessionModalSequence from './SessionModalSequence';
import styles from './Layout.module.scss';

type Props = {
  children: ReactNode;
};

function WithSidebar({ children }: Props) {
  useSessionInitialSetup();
  const isMobile = useIsMobile();
  const { pathname } = useLocation();
  const isNotDashboard = pathname !== '/dashboard';
  const isOffersAndUpgradesPage =
    pathname === '/my-account/offers-and-upgrades';
  const pageWrapperClassName = clsx({
    [styles.pageSectionWrapper]: isNotDashboard && !isOffersAndUpgradesPage,
    [styles.pageSectionWrapperOffers]: isOffersAndUpgradesPage,
  });

  // DashboardSummaryProvider is mounted at the LayoutWithSider level
  // (Layout.tsx) so it wraps both the Header (mobile menu drawer) and
  // this WithSidebar tree — keeping a single shared instance for every
  // consumer.
  return (
    <Layout className={styles.withSiderbarContainer}>
      <If condition={!isMobile}>
        <Sidebar />
      </If>
      <Flex vertical className={`${styles.contentWrapper} alignStretch`}>
        <Layout.Content
          className={`${styles.content} ${styles.contentAuth} verticalFlex alignStretch`}
        >
          <CriticalNotification />
          <Flex vertical className={pageWrapperClassName}>
            {children}
            <SessionModalSequence />
          </Flex>
        </Layout.Content>
        <Footer />
      </Flex>
    </Layout>
  );
}

export default WithSidebar;
